import { render, staticRenderFns } from "./PaymentBatchItem.vue?vue&type=template&id=118317b8"
import script from "./PaymentBatchItem.vue?vue&type=script&lang=js"
export * from "./PaymentBatchItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports